import { DocumentTextIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { TrackedFile } from '../hooks/useReceiptUpload';

import FileDragDropZone from './FileDragDropZone';
import FileListItem from './FileListItem';

interface FileSelectionPanelProps {
  trackedFiles: TrackedFile[];
  onFilesAdded: (files: FileList) => void;
  onRemoveFile: (id: string) => void;
  disabled?: boolean;
}

const FileSelectionPanel: React.FC<FileSelectionPanelProps> = ({
  trackedFiles,
  onFilesAdded,
  onRemoveFile,
  disabled = false,
}) => {
  return (
    <div>
      <h4 className='text-sm font-medium text-gray-700 dark:text-gray-300 mb-3'>
        Selected Files ({trackedFiles.length})
      </h4>
      <FileDragDropZone
        onFilesAdded={onFilesAdded}
        disabled={disabled}
        accept='.pdf'
        footer={
          <p className='text-xs text-gray-400 dark:text-gray-500 text-center pt-2'>
            Click here or drop files to add more
          </p>
        }
      >
        {trackedFiles.length === 0 ? (
          <div className='text-center py-8'>
            <DocumentTextIcon className='w-10 h-10 mx-auto text-gray-400 dark:text-gray-500 mb-3' />
            <p className='text-sm text-gray-500 dark:text-gray-400 mb-1'>
              No file selected
            </p>
          </div>
        ) : (
          <div className='space-y-2 max-h-60 overflow-y-auto'>
            {trackedFiles.map(trackedFile => (
              <FileListItem
                key={trackedFile.id}
                trackedFile={trackedFile}
                onRemove={onRemoveFile}
              />
            ))}
          </div>
        )}
      </FileDragDropZone>
    </div>
  );
};

export default FileSelectionPanel;
